<script setup lang="ts">
import {onMounted} from 'vue';
import CabHeader from '@/views/header/CabHeader.vue';
import {reload} from '@/base/loadingState.js';
import {RouterView} from 'vue-router';

onMounted(async () => {
    await reload();
});
</script>

<template>
    <div class="h-screen relative">
        <CabHeader/>
        <RouterView/>
    </div>
</template>
